<template>
  <div class="table-wrapper">
    <div style="display: flex;justify-content: flex-end;">
      <place-select v-model="areaCode"></place-select>
      <DatePicker
          style="margin-left: 20px;"
          type="daterange"
          :value="time"
          @on-change="kqDateChange"
          :options="pickerOptions"
          placeholder="请选择"
          transfer
        ></DatePicker>
    </div>
    <trendStatisticsType :time1="time" :areaCode1="areaCode"></trendStatisticsType>
    <statisticalList :time1="time" :areaCode1="areaCode"></statisticalList>
    <div class="choose-container">
      <DatePicker type="daterange" :value="timeValueArr" :options="pickerOptions" show-week-numbers placement="bottom-end" placeholder="请选择日期" style="width: 200px" @on-change="changeDateHandle"></DatePicker>
      <Select v-model="targetValue" multiple style="width:560px" class="select-self" @on-change="changeHandle" >
          <Option v-for="item in targetValueList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </div>
    <div class="trend-statistics-wrapper">
      <div class="chart-container"  v-if="targetValue.length > 0">
        <div class="fchart-bi" style="height: 455px" ref="chartLine">出勤统计</div>
      </div>
      <div  style="height: 455px"  v-if="targetValue.length == 0" class="no-data-style">暂无数据</div>
    </div>
  </div>
</template>
<script>
import trendStatisticsType from "./trendStatisticsType";
import statisticalList from "./statisticalList";
import { format } from "../../../utils/forMat";
import tableMixin from "@/components/tableMixin";
let echarts = require('echarts');
let nameRateArr = ['项目更新率','项目停工率','项目经理到岗率','项目总监到岗率','项目经理和总监理工程师到岗率']
export default {
mixins: [tableMixin],
  data() {
    return {
      chartLine:null,
      displayVis:true,
      optionObj:{
                legend: {
                  type:'scroll',
                  orient: 'horizontal',
                  top:5,
                  left:80
                },
                tooltip: {
                  axisPointer: {
                    type: 'shadow'
                  },
                  trigger: 'axis',
                  formatter: function(params) {
                  let str = '';
                  params.forEach((item,idx) => {
                    str += `${item.marker}${item.seriesName}: ${item.data}`
                    if(nameRateArr.includes(item.seriesName)){
                     str += '%';
                    }
                    str += idx === params.length -1? '': '<br/>'
                  })
                  return str
                }
                },
                grid:{
                    left: 60,
                    right:60,
                    top: 40,
                    bottom: 40,
                },
                xAxis:{
                    name:'日期',
                    nameTextStyle:{
                        align:'right',
                        padding:[30,-10,0,0]
                    },
                    /* 类目轴*/
                    type:'category',
                    axisLabel:{
                        interval:0,
                        rotate: 38
                    },
                    axisTick: {
                        alignWithLabel: true
                    },
                    data: []
                },
                yAxis:[],
                series: []
      },
      timeValueArr:[],
      targetValue:['atendanceProjectsuperviseRate','projectStopRate'],
      rateArr:['atendanceProjectsuperviseRate','projectStopRate','buildManagerAverageToPostRate','supervisionManagerAverageToPostRate','managerAndChiefInspectorAttendanceRate'],
      targetValueList:[
         {
              value: 'atendanceProjectsuperviseRate',
              label: '项目更新率'
          },
           {
              value: 'projectStopRate',
              label: '项目停工率'
          },
          {
              value: 'avgWorkerCount',
              label: '有考勤项目的平均上班工人数'
          },
          {
              value: 'buildManagerAverageToPostRate',
              label: '项目经理到岗率'
          },
           {
              value: 'supervisionManagerAverageToPostRate',
              label: '项目总监到岗率'
          },
          {
              value: 'managerAndChiefInspectorAttendanceRate',
              label: '项目经理和总监理工程师到岗率'
          },
          {
              value: 'notSetProjectManagersNum',
              label: '未设置项目经理的项目数'
          },
          {
              value: 'notSetProjectDirectorNum',
              label: '未设置总监理工程师的项目数'
          },
          {
              value: 'setProjectManagersNotCertifiedArchitectNum',
              label: '已设置但非注册建造师的项目数'
          },
          {
              value: 'setProjectDirectorNotRegisteredSupervisorNum',
              label: '已设置但非注册监理工程师的项目数'
          },
          //  {
          //     value: 'projectExceedNoCheckMessageNum',
          //     label: '项目超期未审核预警'
          // },
          //  {
          //     value: 'supplierExceedNoJointMessageNum',
          //     label: '供应商超期未联调预警'
          // },
          // {
          //     value: 'supplierExceedNoCheckMessageNum',
          //     label: '供应商超期未审核办件数'
          // },
      ],
      countArr:['avgWorkerCount','notSetProjectManagersNum','notSetProjectDirectorNum','setProjectManagersNotCertifiedArchitectNum','setProjectDirectorNotRegisteredSupervisorNum','projectExceedNoCheckMessageNum','supplierExceedNoJointMessageNum', 'supplierExceedNoCheckMessageNum'],
      time: [],
      singleOrdouble:false,
      areaCode: this.common.getTenantAreaCode(),
      resultArr:[],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  components: {
    trendStatisticsType,
    statisticalList,
  },
  computed: {},
  watch: {
    areaCode: {
      handler() {
        this.queryTrendStatisticsLineData();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
          //引入echarts 初始化图标
      // 工资发放情况
      this.chartLine = echarts.init(this.$refs.chartLine);
      this.queryTrendStatisticsLineData()
      window.addEventListener('resize',this.resize);
      window.addEventListener('load',this.resize);
      /*加载完成自适应*/
      this.$nextTick( ()=> {
          this.resize();
      });
  },
  methods: {
    // echarts 适应
    resize(){
        this.chartLine.resize();
    },
    // 人员出勤监管查询
    queryTrendStatisticsLineData(){
        this.chartLine.showLoading();
        this.axios({
            method: 'post',
            url: '/gd/trendStatistics/queryTrendStatisticsLineData',
            data:{
                "areaCode":this.areaCode,
                "areaType":null,
                "startDate":this.timeValueArr.length > 0 ? this.timeValueArr[0] : this.$moment(new Date() - 86400000*31).format('YYYY-MM-DD'),
                "endDate":this.timeValueArr.length > 0 ? this.timeValueArr[1] : this.$moment(new Date() - 86400000).format('YYYY-MM-DD')
            }
        }).then( (response)=> {
            if (response.data.data){
              this.resultArr = response.data.data
                let xData=[];
                this.resultArr.forEach(item=>{
                  let str = item.workDate
                  let date = str.slice(5)
                  xData.push(date);
                });
                this.optionObj.xAxis.data = xData
                this.handleyYAxis()
                this.handleySeries()
                // this.optionObj.dataZoom = xData.length > 15 ? [
                //             {
                //                 startValue : 0,
                //                 endValue : 17,
                //                 type: 'slider',
                //                 show: true,
                //                 xAxisIndex: [0],
                //                 height: 10,
                //                 bottom: 8,
                //                 borderRadius: 5,
                //                 showDataShadow: false,
                //                 showDetail: false,
                //                 realtime: true
                //             }
                //         ] : []
                this.chartLine.setOption(this.optionObj);
                this.chartLine.hideLoading();
            }
        });
    },
    handleySeries(){
      let series = []
      this.targetValue.forEach(item=>{
         let dataArr = this.resultArr.map(ele=>{
           if(ele[item] && ele[item].toString().includes('%')){
             ele[item] = ele[item].replace('%','')
           }
           return ele[item]*1
         })
         let name = this.targetValueList.filter(k=>k.value == item)[0].label
         let obj = {
              type: 'line',
              smooth: true,
              name: name,
              keyValue:item,
              yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
              data:dataArr,
          }
         if(this.singleOrdouble){
           if(this.countArr.includes(item)){
             obj['yAxisIndex'] = 0
           }
         } else {
           delete obj.yAxisIndex
         }
          series.push(obj)
      })
      this.optionObj.series = series
    },
    handleyYAxis(){
      this.optionObj.yAxis = []
      let flagCount = this.targetValue.some(item=>{
         return this.countArr.includes(item)
      })
      if(flagCount){
        this.optionObj.yAxis.push({
                    name:'数量',
                    type:'value',
                    splitLine: {
                        show: true, //网格线开关
                        lineStyle:{
                            type:'dashed'
                        },
                        axisLine:{
                            show: false
                        },
                    },
                    axisLine:{
                        show: false
                    },
                    minInterval: 1,
                    })
      }
      let flagRate = this.targetValue.some(item=>{
         return this.rateArr.includes(item)
      })
      if(flagRate){
        this.optionObj.yAxis.push({
                    name:'%',
                    type:'value',
                    // min: 0,
                    // max: 100,
                    splitNumber : 5,
                    splitLine: {
                        show: true, //网格线开关
                        lineStyle:{
                            type:'dashed'
                        },
                        axisLine:{
                            show: false
                        },
                    },
                    axisLine:{
                        show: false
                    },
                    // minInterval: 1,
                    })
      }
      if(flagCount && flagRate){
        this.singleOrdouble = true
      } else {
        this.singleOrdouble = false
      }
    },
    changeDateHandle(e){
      if (e[0] == '' || e[1] == '') {
        return this.$Message.warning({
          content: '请选择日期范围！',
        });
      }
      let start = Date.parse(e[0])
      let end = Date.parse(e[1])
      let range = 86400000*31
      if ((end - start) > range) {
        return  this.$Message.warning({
                  content: '日期范围不能超过31天！',
                  duration: 3,
                });
      }
      this.timeValueArr = e
      this.queryTrendStatisticsLineData()
    },
    changeHandle(){
      if(this.targetValue.length == 0){
        return
      }
      this.handleyYAxis()
      this.handleySeries()
      this.$nextTick(() => {
         //  增加可以重新绘制echarts但是 减少不会重新绘制 故增加此方法
        document.querySelector('.fchart-bi').removeAttribute('_echarts_instance_')
        this.chartLine = null
        this.chartLine = echarts.init(this.$refs.chartLine);
        this.chartLine.setOption(this.optionObj);
        this.chartLine.showLoading();
        this.chartLine.hideLoading();
      });
    },
    kqDateChange(e) {
      this.time = e
    },
    getTableData() {
      this.areaCode = this.common.getTenantAreaCode()
      //当前设定的日期时间
      let d = new Date(Date.now() - 86400000);
      let e = new Date(Date.now() - 86400000*31);
      //前一天设定的日期时间
      let year2, month2, day2;
      let year3, month3, day3;
      d.setTime(d.getTime());
      e.setTime(e.getTime());
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
      [year3, month3, day3] = [e.getFullYear(), e.getMonth(), e.getDate()];
      let timeChanges1 = new Date(year2, month2, day2, 0);
      let timeChanges2 = new Date(year3, month3, day3, 0);
      this.time = [
        format(timeChanges1, "yyyy-MM-dd"),
        format(timeChanges1, "yyyy-MM-dd"),
      ];
      this.timeValueArr = [
        format(timeChanges2, "yyyy-MM-dd"),
        format(timeChanges1, "yyyy-MM-dd"),
      ]
    },
  },
};
</script>
<style lang="less">
.trend-statistics-wrapper{
  margin-top: 60px;
}
.choose-container{
  position: absolute;
  right: 25px;
    .select-self{
      margin-left: 20px;
      .ivu-select-selection {
          height: 32px;
          overflow: auto;
      }
    }
  }
.no-data-style{
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
